import React from 'react';
import { Link } from 'react-router-dom';
import './AboutAbhikalp.css';

function AboutAbhikalp() {
  return (
    <div className="about-wrapper">
      <div className="about-hero">
        {/* Make sure logo is in public/images/ */}
        <img src="/images/abhikalp-logo.png" alt="Abhikalp" className="about-logo" />
        <h1>Strategic Clarity for Founders</h1>
        <p className="hero-text">
          More than a service — a philosophy of protection, renewal, and strategic preparation.
        </p>
      </div>

      <div className="about-content">
        <section className="section-block">
          <h2>The Abhikalp Vision</h2>
          <p>
            Abhikalp is the flagship platform of <strong>ARK Strategic Management Consultancy Services</strong>.
            We believe that legal support should not be an emergency service — it should be a
            strategic asset.
          </p>
          <div className="quote-box">
            "The future of legal support lies not in hourly billing, but in strategic enablement."
          </div>
          <p>
            The name <strong>ARK</strong> represents both a personal tribute and the timeless symbol
            of the <em>Ark</em> — a vessel built for protection and direction during a storm. We build
            that vessel for your business.
          </p>
        </section>

        <section className="founder-section">
          <div className="founder-img-col">
            {/* Make sure photo is in public/images/ */}
            <img src="/images/rushil-aiya.jpg" alt="Rushil Aiya" className="founder-photo" />
          </div>
          <div className="founder-text-col">
            <h2>Meet the Founder</h2>
            <h3>Rushil Aiya</h3>
            <p className="role">Legal Strategist & Consultant</p>
            <p>
              Starting as a litigating advocate, Rushil realized that most business owners
              only called him when disaster struck. He transitioned from the courtroom to
              the boardroom to help founders <strong>prevent</strong> crises.
            </p>
            <p>
              With expertise in corporate law, risk mapping, and backend systems, he now
              empowers founders to navigate complexity with absolute control.
            </p>
          </div>
        </section>

        <section className="cta-block">
          <h2>Ready to build your Ark?</h2>
          {/* Linked to Support for the static site */}
          <Link to="/support" className="cta-btn">Get in Touch</Link>
        </section>
      </div>
    </div>
  );
}

export default AboutAbhikalp;